//Please add the language resource
const cost = {
  checkoutStatus: 'checkoutStatus',
  checkoutMethod: 'checkoutMethod',
  shipperCode: 'shipperCode',
  shipperName: 'shipperName',
  projectName: 'projectName',
  dispatchNo: 'dispatchNo',
  customerOrderNo: 'customerOrderNo',
  soOrSto: 'soOrSto',
  truckNo: 'truckNo',
  orderDate: 'orderDate',
  carrierName: 'carrierName',
  originNo: 'originNo',
  originName: 'originName',
  destNo: 'destNo',
  destName: 'destName',
  destProvince: 'destProvince',
  destCity: 'destCity',
  destDistrict: 'destDistrict',
  destAddress: 'destAddress',
  deliverGoodsTime: 'deliverGoodsTime',
  route: 'route',
  realityReachTime: 'realityReachTime',
  totalQty: 'totalQty',
  totalGrossWeight: 'totalGrossWeight',
  totalVolume: 'totalVolume',
  freight: 'freight',
  deliveryFee: 'deliveryFee',
  deliveryCharge: 'deliveryCharge',
  packageFare: 'packageFare',
  elseExpense: 'elseExpense',
  totalExpense: 'totalExpense',
  remark: 'remark'
};
export default cost



// WEBPACK FOOTER //
// ./src/page/settlementFee/cost/lang/cost.en.js